import React, { useEffect, useState, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function HeroSlider({ images = [] }) {
    const [idx, setIdx] = useState(0);
    const [dir, setDir] = useState(1);

    const next = useCallback(() => {
        if (!images.length) return;
        setDir(1);
        setIdx((v) => (v + 1) % images.length);
    }, [images.length]);

    const prev = useCallback(() => {
        if (!images.length) return;
        setDir(-1);
        setIdx((v) => (v - 1 + images.length) % images.length);
    }, [images.length]);

    useEffect(() => {
        if (!images.length) return;
        const t = setInterval(() => next(), 6500);
        return () => clearInterval(t);
    }, [images.length, next]);

    if (!images.length) return <div className="w-full h-full bg-white/10" />;

    const SWIPE_OFFSET = 80;
    const SWIPE_VELOCITY = 700;

    return (
        <div className="relative w-full h-full overflow-hidden">
            <AnimatePresence mode="wait" custom={dir}>
                <motion.img
                    key={idx}
                    src={images[idx]}
                    alt=""
                    className="absolute inset-0 w-full h-full object-fill md:object-cover select-none"
                    draggable={false}
                    custom={dir}
                    // initial={(d) => ({ x: d > 0 ? 80 : -80, opacity: 0.6 })}
                    // animate={{ x: 0, opacity: 1 }}
                    // exit={(d) => ({ x: d > 0 ? -80 : 80, opacity: 0.6 })}
                    transition={{ duration: 1.05, ease: "easeInOut" }}

                    // ✅ swipe
                    drag="x"
                    dragConstraints={{ left: 0, right: 0 }}
                    dragElastic={0.08}
                    style={{ touchAction: "pan-y" }}   // ✅ มือถือเลื่อนแนวตั้งได้ ลากแนวนอนได้
                    onDragEnd={(e, info) => {
                        const offsetX = info.offset.x;
                        const velocityX = info.velocity.x;

                        if (offsetX < -SWIPE_OFFSET || velocityX < -SWIPE_VELOCITY) return next();
                        if (offsetX > SWIPE_OFFSET || velocityX > SWIPE_VELOCITY) return prev();
                    }}
                />
            </AnimatePresence>

            {/* overlay (อย่ารับคลิก) */}
            {/* <div className="absolute inset-0 bg-black/15 pointer-events-none" /> */}

            {/* dots */}
            {images.length > 1 && (
                <div
                    className="absolute bottom-16 left-0 right-0 flex justify-center gap-2 z-20"
                    onPointerDown={(e) => e.stopPropagation()} // ✅ กันโดน drag แย่ง event
                >
                    {images.map((_, i) => (
                        <button
                            key={i}
                            type="button"
                            onClick={() => {
                                setDir(i > idx ? 1 : -1);
                                setIdx(i);
                            }}
                            className={`h-1.5 transition w-6 ${i === idx ? "bg-white" : "bg-white/50 hover:bg-white/70"
                                }`}
                            aria-label={`slide-${i + 1}`}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}
